import { useAppRouterState } from '@/app/addRouter';
import { useStackContext } from '@/components/Layout/Stack/StackContext';

/**
 * Returns the full resolved path for the deepest active panel in the
 * current stack. Panels that need to detect whether a child route is
 * active can opt in to this hook.
 *
 * Note: this value changes on every navigation, so only use it in
 * panels that genuinely need it to avoid unnecessary re-renders.
 */
export function useStackPath(): string {
  const { stackIdx } = useStackContext();
  const { drillDownPaths } = useAppRouterState();
  const drillDownPath = drillDownPaths[stackIdx]?.drillDownPath;
  return drillDownPath?.at(-1)?.path ?? '';
}
